const removeAllAt = <T>(
  prev: T[],
  indexOrFinder: number | ((exists: T, index: number) => boolean)
): T[] => {
  return prev.filter((_, i) =>
    typeof indexOrFinder === 'number' ? i !== indexOrFinder : !indexOrFinder(_, i)
  );
};

export default removeAllAt;
